import { ApiModule, httpClient } from '../api';

export async function saveFarmer(farmerERP) {
  return httpClient().post(`${ApiModule.BusinessManagement}/ProveedorGuardar/`, farmerERP);
}

export async function removeFarmer(farmer) {
  return httpClient().delete(`${ApiModule.BusinessManagement}/ProveedorBorrar/`, { data: { id: farmer.id_external } });
}

export async function removeField(field) {
  return httpClient().post(`${ApiModule.AgroCommon}/FincaBorrar/`, { id: field.id_external });
}

export async function saveField(fieldERP) {
  return httpClient().post(`${ApiModule.AgroCommon}/FincaGuardar/`, fieldERP);
}

export async function removeCrop(crop) {
  return httpClient().post(`${ApiModule.AgroCommon}/CultivoBorrar/`, { id: crop.id_external });
}

export async function saveCrop(cropERP) {
  return httpClient().post(`${ApiModule.AgroCommon}/CultivoGuardar/`, cropERP);
}

export async function removeContract(contract) {
  return httpClient().post(`${ApiModule.Shopping}/ContratoCompraTantoAlzadoBorrar/`, { id: contract.id_external });
}

export async function saveContract(contractERP) {
  return httpClient().post(`${ApiModule.Shopping}/ContratoCompraTantoAlzadoGuardar/`, contractERP);
}
